import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useAccounts() {
  const [accounts, setAccounts] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const reload = useCallback(() => api.get("/accounts").then((r) => { setAccounts(r.data); setLoaded(true); }), []);
  useEffect(() => { reload(); }, [reload]);
  return { accounts, loaded, reload };
}
